(function () {
  var WRAPPER_SELECTOR = '.faq-wrapper';
  var ITEM_SELECTOR = '.faq-item';
  var ANSWER_SELECTOR = '.faq-item__answer';
  var ANIMATION_MS = 300;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function cancelAnimation(details) {
    if (details._faqAnimation) {
      details._faqAnimation.cancel();
      details._faqAnimation = null;
    }
  }

  function closeDetails(details) {
    var answer = details.querySelector(ANSWER_SELECTOR);
    var summary = details.querySelector('summary');

    cancelAnimation(details);
    if (summary) summary.setAttribute('aria-expanded', 'false');

    if (!answer || prefersReducedMotion() || typeof answer.animate !== 'function') {
      details.removeAttribute('open');
      return;
    }

    var startHeight = answer.getBoundingClientRect().height;
    answer.style.overflow = 'hidden';
    answer.style.height = startHeight + 'px';

    requestAnimationFrame(function () {
      details._faqAnimation = answer.animate(
        [{ height: startHeight + 'px' }, { height: '0px' }],
        { duration: ANIMATION_MS, easing: 'ease' }
      );

      details._faqAnimation.onfinish = function () {
        details.removeAttribute('open');
        answer.style.height = '';
        answer.style.overflow = '';
        details._faqAnimation = null;
      };
    });
  }

  function openDetails(details) {
    var answer = details.querySelector(ANSWER_SELECTOR);
    var summary = details.querySelector('summary');

    cancelAnimation(details);
    details.setAttribute('open', '');
    if (summary) summary.setAttribute('aria-expanded', 'true');

    if (!answer || prefersReducedMotion() || typeof answer.animate !== 'function') return;

    var endHeight = answer.scrollHeight;
    answer.style.overflow = 'hidden';
    answer.style.height = '0px';

    requestAnimationFrame(function () {
      details._faqAnimation = answer.animate(
        [{ height: '0px' }, { height: endHeight + 'px' }],
        { duration: ANIMATION_MS, easing: 'ease' }
      );

      details._faqAnimation.onfinish = function () {
        answer.style.height = '';
        answer.style.overflow = '';
        details._faqAnimation = null;
      };
    });
  }

  function onSummaryClick(event) {
    var summary = event.currentTarget;
    var details = summary.parentElement;
    if (!details || details.tagName !== 'DETAILS') return;

    event.preventDefault();

    var wrapper = details.closest(WRAPPER_SELECTOR);
    var isOpen = details.hasAttribute('open');

    if (wrapper) {
      wrapper.querySelectorAll(ITEM_SELECTOR + ' > details[open]').forEach(function (openEl) {
        if (openEl !== details) closeDetails(openEl);
      });
    }

    if (isOpen) {
      closeDetails(details);
    } else {
      openDetails(details);
    }
  }

  function initItem(details) {
    if (details.dataset.faqInit === 'true') return;

    var summary = details.querySelector('summary');
    if (!summary) return;

    details.dataset.faqInit = 'true';
    summary.setAttribute('aria-expanded', details.hasAttribute('open') ? 'true' : 'false');
    summary.addEventListener('click', onSummaryClick);
  }

  function destroyItem(details) {
    var summary = details.querySelector('summary');
    if (summary) summary.removeEventListener('click', onSummaryClick);
    delete details.dataset.faqInit;
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll(WRAPPER_SELECTOR + ' ' + ITEM_SELECTOR + ' > details').forEach(initItem);
  }

  function destroyAll(root) {
    if (!root) return;
    root.querySelectorAll(WRAPPER_SELECTOR + ' ' + ITEM_SELECTOR + ' > details').forEach(destroyItem);
  }

  function onLoadMoreClick(event) {
  var button = event.currentTarget;
  var wrapper = button.closest(WRAPPER_SELECTOR);
  if (!wrapper) return;

  wrapper.classList.add('faq-mobile-expanded');

  wrapper.querySelectorAll(ITEM_SELECTOR + '[hidden]').forEach(function (item) {
    item.hidden = false;
  });

  button.closest('.faq-load-more').remove();
}
    

  function initLoadMore(root) {
    var scope = root || document;
    scope.querySelectorAll(WRAPPER_SELECTOR).forEach(function (wrapper) {
  wrapper.querySelectorAll(ITEM_SELECTOR).forEach(function (item, index) {
    item.classList.toggle('faq-mobile-hidden', index >= 4);
  });
});
    scope.querySelectorAll(WRAPPER_SELECTOR + ' .faq-load-more__btn').forEach(function (button) {
      if (button.dataset.faqLoadMoreInit === 'true') return;
      button.dataset.faqLoadMoreInit = 'true';
      button.addEventListener('click', onLoadMoreClick);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
      initLoadMore();
    });
  } else {
    initAll();
    initLoadMore();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
    initLoadMore(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyAll(event.target);
  });
})();
